function isAuth({ app, redirect, route }) {
  const isLoggedIn = !!app.$apolloHelpers.getToken();
  if (isLoggedIn && ['/login', '/welcome'].includes(route.path)) {
    redirect(`${process.env.baseUrl}/app/dashboard`);
  }
}

export default isAuth;
